export const sizes = {
  auto: 'auto',
  none: '0px',
  xxs: '8px',
  xs: '16px',
  s: '24px',
  m: '32px',
  l: '40px',
  xl: '48px',
  xxl: '56px',
  gridGutter: '12px',
  gridMargin: '24px',

  '-xxs': '-8px',
  '-xs': '-16px',
  '-s': '-24px',
  '-m': '-32px',
  '-l': '-40px',
  '-xl': '-48px',
  '-xxl': '-56px',
  '-gridGutter': '-12px',
  '-gridMargin': '-24px',
};
